export const CONST_ACCESS_TOKEN = "diad.accessToken";
export const CONST_USER = "diad.participante";
export const MONEY_SIMBOL = "S/ ";
export const ROLES = {
  ADMIN: "admin",
  ORGANIZER: "organizer"
};

// ----- Estructura del formulario -----

export const formLayout = {
  formItemLayout: {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 }
    }
  },
  tailFormItemLayout: {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0
      }
    }
  }
};
